import React from 'react';

import { TpDashboardContext, TpDashboardElement, TpStaticTextDefinition } from '../../dashboard/interfaces';
import { TpDataContext } from '../../../../data/interfaces';
import { useAppDispatch } from '../../../../app/hooks';
import { ElementEditTools } from '../../dashboard/edit-mode/ElementEditTools';
import Markdown from 'react-markdown';

interface TpStaticTextProps {
  parentElemDef: TpDashboardElement | null;
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  elemDef: TpStaticTextDefinition;
}

function StaticText({ dataContext, parentElemDef, elemDef, dashboardContext }: TpStaticTextProps) {
  const dispatch = useAppDispatch();

  return (
    <div style={{ position: 'relative' }}>
      <Markdown>{elemDef.content}</Markdown>
      {dashboardContext.editMode && (
        <ElementEditTools
          dataContext={dataContext}
          dashboardContext={dashboardContext}
          parentElemDef={parentElemDef}
          elemDef={elemDef}
          dispatch={dispatch}
        />
      )}
    </div>
  );
}

export default StaticText;
